import React from "react";

const azure = "#20A39E";

export const CardOutIcon = () => {
	return (
		<svg width="41" height="24" viewBox="0 0 41 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M23.4124 2.9883C23.0207 2.59667 22.55 2.40088 22.0001 2.40088H1.99999C1.45 2.40088 0.979306 2.59663 0.587417 2.9883C0.195747 3.38001 0 3.85071 0 4.40074V19.6005C0 20.1507 0.195747 20.6214 0.587417 21.0131C0.979306 21.4048 1.45 21.6006 1.99999 21.6006H22.0001C22.55 21.6006 23.0207 21.4048 23.4124 21.0131C23.804 20.6215 24 20.1507 24 19.6005V4.40074C24 3.85071 23.804 3.38001 23.4124 2.9883ZM22.3998 19.6008C22.3998 19.7093 22.3603 19.8028 22.2811 19.8822C22.202 19.961 22.1082 20.0006 22.0001 20.0006H1.99999C1.89171 20.0006 1.79793 19.961 1.71878 19.8819C1.63966 19.8025 1.60004 19.709 1.60004 19.6005V12.0007H22.3999V19.6008H22.3998ZM22.3998 7.20057H1.6V4.40056C1.6 4.29225 1.63949 4.19868 1.71873 4.11935C1.79793 4.04041 1.89171 4.00079 1.99994 4.00079H22C22.1082 4.00079 22.202 4.04024 22.2811 4.11935C22.3602 4.19868 22.3998 4.29225 22.3998 4.40056V7.20057H22.3998Z"
				fill={azure}
			/>
			<path d="M6.40028 16.8H3.20032V18.4002H6.40028V16.8Z" fill={azure} />
			<path d="M12.8 16.8H8.00006V18.4002H12.8V16.8Z" fill={azure} />
			<path d="M26 12L33.5 6.80385L33.5 17.1962L26 12Z" fill={azure} />
			<rect x="41" y="14" width="10" height="4" transform="rotate(-180 41 14)" fill={azure} />
		</svg>
	);
};
